<template>
  <span :class="ns.e('total')" :disabled="disabled">
    {{
      t('b.pagination.total', {
        first: (current - 1) * sizes + 1,
        last: current * sizes > total ? total : current * sizes,
        total,
      })
    }}
  </span>
</template>

<script lang="ts" setup>
import { useLocale, useNamespace } from '@bigin/hooks'
import { usePagination } from '../usePagination'
import { paginationTotalProps } from './total'

const { t } = useLocale()
const ns = useNamespace('pagination')
const { disabled } = usePagination()

defineOptions({
  name: 'BPaginationTotal',
})

defineProps(paginationTotalProps)
</script>
